import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppService } from '../../../app.service';
import { AdminGridDirective, AdminGridConfig, AdminGridCallbackEvent } from '../../shared/admin-grid.directive';
import { GridBuilderEditComponent } from './grid-builder-edit.component';
import { AdminScreenContextService } from '../../shared/admin-screen-context.service';

@Component({
    selector: 'gtw-grid-builder',
    templateUrl: './grid-builder.component.html',
    styleUrls: ['./grid-builder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GridBuilderComponent implements OnInit, OnDestroy {
  @ViewChild(AdminGridDirective) adminGrid!: AdminGridDirective;

  gridConfig!: AdminGridConfig;
  loading = false;
  title = 'Grid List';

  private readonly ACTION_ID = 89;
  private readonly GRID_ID = '36';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private appService: AppService,
    private dialog: MatDialog,
    private adminScreenContext: AdminScreenContextService,
  ) {}

  ngOnInit(): void {
    const isListMode = this.route.snapshot.data?.['listMode'] === true;
    this.title = isListMode ? 'Grid List' : 'Grid Builder';

    const clientKey = this.appService.USER_SETTINGS?.user?.client?.client_key ?? this.appService.USER_SETTINGS?.user?.client_key ?? '';
    this.gridConfig = {
      actionId: this.ACTION_ID,
      gridId: this.GRID_ID,
      extraParams: { client_key: clientKey },
      autoLoad: true,
      cacheKey: 'admin/grid-list',
    };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onGridCallback(event: AdminGridCallbackEvent): void {
    const rowData = event.data?.rowData ?? event.data;
    this.openEditModal(rowData);
  }

  onGridDataLoaded(_data: any): void {
    this.loading = false;
    this.cdr.detectChanges();
  }

  refresh(): void {
    this.adminGrid?.clearCache();
    this.adminGrid?.refresh();
  }

  addGrid(): void {
    this.openEditModal(null);
  }

  private openEditModal(rowData: any): void {
    const config = new MatDialogConfig();
    config.panelClass = 'admin-modal-panel';
    config.width = '98vw';
    config.maxWidth = '98vw';
    config.disableClose = true;
    config.data = {
      rowData: rowData || {},
    };

    this.adminScreenContext.setRowData(rowData);
    const ref = this.dialog.open(GridBuilderEditComponent, config);
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        this.adminScreenContext.setRowData({});
        if (result === 'saved') {
          this.adminGrid?.clearCache();
          this.adminGrid?.refresh();
        }
      });
  }
}
